
import { useState } from 'react'
import { login } from '../api'
export default function Login({ onLogin }) {
  const [form, setForm] = useState({ login: '', password: '' })
  const [error, setError] = useState('')
  const handle = async () => { try { const { data } = await login(form.login, form.password); localStorage.setItem('token', data.token); localStorage.setItem('role', data.role); localStorage.setItem('name', data.name); onLogin(data.role) } catch { setError('Неверный логин или пароль') } }
  const s = { input: { width:'100%',padding:'12px 14px',borderRadius:'12px',border:'1.5px solid #e5e7eb',fontSize:'14px',outline:'none',boxSizing:'border-box',marginBottom:'16px' } }
  return (
    <div style={{minHeight:'100vh',background:'#F5F5F5',display:'flex',alignItems:'center',justifyContent:'center'}}>
      <div style={{background:'#fff',padding:'40px',borderRadius:'24px',width:'360px'}}>
        <div style={{display:'flex',alignItems:'center',gap:'10px',marginBottom:'32px'}}>
          <div style={{width:'36px',height:'36px',background:'#38BDF8',borderRadius:'10px'}}></div>
          <span style={{fontSize:'18px',fontWeight:'700'}}>CRM HUB</span>
        </div>
        {error && <p style={{color:'#ef4444',marginBottom:'12px',fontSize:'14px'}}>{error}</p>}
        <p style={{fontSize:'13px',color:'#6b7280',marginBottom:'6px',fontWeight:'600'}}>Логин</p>
        <input placeholder='Введите логин' value={form.login} onChange={e=>setForm({...form,login:e.target.value})} style={s.input} />
        <p style={{fontSize:'13px',color:'#6b7280',marginBottom:'6px',fontWeight:'600'}}>Пароль</p>
        <input type='password' placeholder='Введите пароль' value={form.password} onChange={e=>setForm({...form,password:e.target.value})} style={{...s.input,marginBottom:'24px'}} />
        <button onClick={handle} style={{width:'100%',padding:'14px',background:'#FBBF24',color:'#fff',border:'none',borderRadius:'14px',fontSize:'16px',fontWeight:'700',cursor:'pointer'}}>Войти</button>
      </div>
    </div>
  )
}
